// extracted by mini-css-extract-plugin
module.exports = {"JoinCommunity":"JoinCommunity_JoinCommunity__WayMB"};